<template>
  <transition name="modal-fade">
    <div @click="close()" class="modal-backdrop">
      <div @click.stop="" class="modal" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">
            <img src="../../assets/logo-essi-expert.svg" />
            <button type="button" class="btn-close" @click="close()" aria-label="Close modal">
              <img class="logo-close" src="../../assets/ic-close.svg" />
            </button>
          </slot>
        </header>
        <section class="modal-body">
          <slot name="body">
            <span class="text">
              Vivez l’expérience Essi’expert,<br />
              le nouvel outil digital de démonstration verres Essilor conçu pour :
              <ul>
                <li>vous accompagner dans votre parcours de vente</li>
                <li>
                  et faire découvrir aux consommateurs les bénéfices et avantages des verres et marques Essilor.
                </li>
              </ul>
            </span>
            <div class="links-modals">
              <div @click="goToHelpModal()" class="help-screen">
                <img width="60" src="../../assets/ic-bebe.svg" />
                <p class="link">Ecrans</p>
                <p class="link">d'aide</p>
              </div>
              <div @click="goToCguModal()" class="cgu">
                <img width="60" src="../../assets/ic-manuel.svg" />
                <p class="link">Conditions Générales</p>
                <p />
                <p class="link">d’Utilisation</p>
              </div>
            </div>
            <h3>POUR TOUTES DEMANDES D’INFORMATIONS OU SUGGESTIONS :</h3>
            <form>
              <textarea v-model="contentMessage" />
            </form>
            <div @click="sendEmail()" class="btn-send">LAISSEZ-NOUS UN MESSAGE</div>
          </slot>
        </section>
        <footer class="modal-footer">
          <slot name="footer">
            <img width="150" src="../../assets/logo-marque/essilor.png" />
            <p>Tous droits réservés © 2020 - Essilor</p>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalReport',
  methods: {
    sendEmail() {
      if (this.contentMessage) {
        this.$store.dispatch('sendEmail', this.contentMessage);
        this.contentMessage = '';
        this.$emit('messageSent');
      }
    },
    goToCguModal() {
      this.$emit('openCguModal');
    },
    goToHelpModal() {
      this.$emit('openHelpModal');
    },
    close() {
      this.contentMessage = '';
      this.$emit('close');
    },
  },
  data: () => {
    return {
      contentMessage: '',
    };
  },
};
</script>

<style scoped>
textarea {
  width: 100%;
  height: 15vh;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 3px solid #0088ec;
  background-color: white;
  font-size: 16px;
  resize: none;
  margin-bottom: 2%;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
h3 {
  font-weight: bolder;
  text-align: left;
  margin-bottom: 2%;
  white-space: nowrap;
}
li:before {
  content: '- ';
}
.modal-backdrop {
  z-index: 2000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal {
  background: #ffffff;
  overflow-x: auto;
  border: solid 2px #0088ec;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  color: black;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.modal-header h2 {
  padding-top: 40px;
  font-size: 20px;
}

.modal-footer {
  align-items: center;
  padding-top: 0;
  width: 100%;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  height: 100%;
  width: 100%;
  padding: 20px 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.btn-close {
  outline: none;
  border: none;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}
.btn-send {
  outline: none;
  cursor: pointer;
  color: white;
  background: #0088ec;
  padding: 4px 10px;
  margin: 0 auto;
  border-radius: 4px;
  font-size: 20px;
  white-space: nowrap;
}

.btn-close img {
  width: 30px;
  filter: invert(35%) sepia(54%) saturate(1964%) hue-rotate(182deg) brightness(101%) contrast(106%);
}

.logo-close {
  border: solid 2px black;
  border-radius: 24px;
}

.links-modals {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 5%;
}
p {
  margin: 0;
  padding: 0;
}
.link {
  color: #0088ec;
  cursor: pointer;
  text-decoration: underline #0088ec;
}

.text {
  margin-bottom: 5%;
}
</style>
